import { EditableTaskFormState } from '@/client/admin-tasks';
import { EditableTaskCard } from '@/components/admin-tasks/EditableTaskCard';
import { DragHandleIcon } from '@/utils/helpers';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import styled from 'styled-components';

const SortableItemWrapper = styled.div`
  position: relative;
  width: 100%;

  &:active {
    cursor: grabbing;
  }
`;

const DragHandle = styled.div`
  position: absolute;
  top: 50%;
  left: var(--small-padding);
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: var(--gray-darker);
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;

  ${SortableItemWrapper}:hover & {
    opacity: 1;
  }

  &:active {
    cursor: grabbing;
  }
`;

const CardContent = styled.div`
  padding-inline: var(--big-padding);
`;

export interface SortableTaskItemProps {
  initialValues: EditableTaskFormState;
  onValuesChange: (values: EditableTaskFormState) => void;
  onDelete?: () => void;
  style?: React.CSSProperties;
}

export const SortableTaskItem: React.FC<SortableTaskItemProps> = ({
  initialValues,
  onValuesChange,
  onDelete,
  style: externalStyle,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: initialValues.taskId,
    });

  const style = {
    ...externalStyle,
    transform: CSS.Transform.toString(transform),
    transition,
    position: 'relative' as const,
    width: '100%',
  };

  return (
    <SortableItemWrapper ref={setNodeRef} style={style}>
      <DragHandle {...attributes} {...listeners}>
        <DragHandleIcon />
      </DragHandle>
      <CardContent>
        <EditableTaskCard
          initialValues={initialValues}
          onValuesChange={onValuesChange}
          onDelete={onDelete}
        />
      </CardContent>
    </SortableItemWrapper>
  );
};
